import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { AnnouncedService } from './services/announced.service';
import { ExcelService } from './services/excel.service';
import { WorkFlow } from '../masterdata/models/workFlow';
import { Plate } from '../models/plate';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { ArrayProject } from '../masterdata/models/arrayProject';
import { SearchAnnounce } from '../models/searchAnnounce';
import { Sample } from '../models/sample';
import { PlateAnnouncementDTO } from '../dto/plateAnnouncementDTO';
import { BBResponseContainer } from '../carrier/response-container';

@Component({
  selector: 'app-apg-announced',
  templateUrl: './apg-announced.component.html',
  styleUrls: ['./apg-announced.component.css']
})
export class ApgAnnouncedComponent implements OnInit {


  errorHandler: ErrorHandler = new ErrorHandler;
  blocked: boolean;
  manualExcelUploadFile: File;

  @ViewChild('csvmanual')
  manualEXELElement: ElementRef;
  //Table configurations
  loading: boolean;
  totalRecords: any;
  isFileNotSelected: boolean = true;
  barCode: string = '';
  fromDate: Date = null;
  toDate: Date = null;
  labId : string;
  lab : string;
  labName : string;
  deliveryLists:any[];
  puid: string;
  projectList = [];
  projectData: ArrayProject[] = [];
  workFlowData: WorkFlow[] = [];
  sampleTypeList = [];
  sampleTypeProcessFlowList = [];
  processFlowData: ProcessFlow[] = [];
  project : ArrayProject;
  workFlow: WorkFlow = new WorkFlow();
  selectedProcessFlow: ProcessFlow = null;
  cols = [
    { field: 'deliveryID', header: 'Delivery ID' },
    { field: 'creationDate', header: 'Creation Date', date: true, format: 'dd/MM/yyyy HH:mm' },
    { field: 'sender', header: 'Sender' },
  ]
  announcedData: any[];
  selectedLabId: string;
  selectedLabName: string;
  shortSenderValueMap = new Map();
  selectedPlate: Plate;
  deliveryIDSelected: boolean = false;
  selectedDeliveryId: string = '';
  sampleList: any[] = [];
  duplicateValues: boolean = false;
  errorMessage: string;
  dupSamples: boolean = false;
  dupPlates: boolean = false;
  dupSamplesList: any[] = [];
  dupPlatesList: any[] = [];
  projectDuplicateMap = new Map();
  //end of Table configurations
  constructor(
    private _messagesService: MessagesService, public datepipe: DatePipe,
    private announcedService: AnnouncedService,
    private masterDataService: MasterDataService,
    private excelService: ExcelService
  ) { }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.selectedLabName = JSON.parse(localStorage.getItem('lab')).lab.name;
    this.puid = localStorage.getItem('PUID');
    this.getSampleTypeList();
  }
  
  page: number = 0
  loadLazy(event) {
    this.loading = true;
    this.searchAnnounceList(event.first, event.rows)
    this.loading = false;
  }

  onRowSelect(event){
    this.selectedDeliveryId = event.data.deliveryID
    this.announcedService.getSamplesOfDelivery(this.selectedLabId, this.selectedDeliveryId).subscribe(res => {
      if(!("data" in res)){
        this._messagesService.addErrorMessage({
        severity:'error', summary:"No samples found",
        detail:"The selected delivery id " +this.selectedDeliveryId +" does not have any samples."
        })
        return;
      }
      this.sampleList = res.data
      for(let i=0;i<this.sampleList.length;i++){
        this.sampleList[i]['plateID'] = 'plateID' in this.sampleList[i] ? this.sampleList[i]['plateID'] : ''
        if(!("barCode" in this.sampleList[i])){
          if("animalNumber" in this.sampleList[i]){
            this.sampleList[i]["barCode"] = this.sampleList[i]["animalNumber"]
          }
          else if("ittNumber" in this.sampleList[i]){
            this.sampleList[i]["barCode"] = this.sampleList[i]["ittNumber"]
          }
        }
      }
      this.deliveryIDSelected = true
      
    })
  }

  getHeader(){
    return "Samples in Delivery ID: "+this.selectedDeliveryId
  }

  searchAnnounceList(skip: number, limit: number) {
    this.loading = true;
    let searchAnnounce = new SearchAnnounce();
    searchAnnounce.labId = this.selectedLabId;
    searchAnnounce.skip = skip;
    searchAnnounce.limit = limit;
    searchAnnounce.barcode = this.barCode;
    searchAnnounce.fromDate = this.fromDate;
    searchAnnounce.dateuntill = this.toDate ? new Date(this.toDate.setDate(this.toDate.getDate() + 1)) : this.toDate;
    this.populateAnnouncedTable(searchAnnounce);
    this.loading = false;
  }
  populateAnnouncedTable(searchAnnounce: SearchAnnounce) {
    this.blocked = true;
    this.deliveryLists = [];
    this.announcedService.getAllDeliveySamples(searchAnnounce).subscribe({	
      next: (result) => {
        this.blocked = false;
        result.data[0].delivery.forEach(element => {
          var data = { deliveryID: element.deliveryID, sender: element.sender, creationDate: element.creationDate.$date }
          this.deliveryLists.push(data);
        });
        if (this.deliveryLists != undefined && this.deliveryLists.length > 0) {
          this.totalRecords = result.data[0].page[0].total;
        } else {
          this.totalRecords = 0;
        }
      },

      error: (_error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plates',
          detail: 'Some issue in pulling the plates info, please try again'
        })
      }})
  }

  //upload
  onFileSelect(filesData) {
    if (filesData.target.files.length > 0) {
      const file = filesData.target.files[0];
      this.manualExcelUploadFile = file;
      this.isFileNotSelected = false;
    } else {
      this.isFileNotSelected = true;
    }
  }
  manualAnnouncement() {
    if(this.project.projectID.trim() == ""){
      this._messagesService.addWarningMessage({
        severity:'warn', summary:'Project not selected!',
        detail: 'Please select the project from the dropdown!'
      });
      return;
    }
    if(this.selectedProcessFlow == null && !this.workFlow.sampleTypeInFile){
      this._messagesService.addWarningMessage({
        severity:'warn', summary:'SampleType not selected!',
        detail: 'Please select the sampleType from the dropdown!'
      });
      return;
   }
    const formData = new FormData();
    formData.append('file', this.manualExcelUploadFile);
    formData.append("labId", this.selectedLabId)
    formData.append("workFlow", this.project.workflow)
    formData.append("sender", this.project.sender)
    formData.append("sampleType", this.selectedProcessFlow? this.selectedProcessFlow.sampleType : "");
    formData.append("processFlowName", this.selectedProcessFlow? this.selectedProcessFlow.processFlowName: "");
    formData.append("projectID", this.project.projectID)
    formData.append("duplicate", String(this.project.duplicate))
    this.blocked = true;
      this.announcedService.uploadManualAnnouncedData(formData).subscribe({
      next: (results) => {
      this.blocked = false;
      if (results.data) {
        if('dupSamples' in results.data || 'dupPlates' in results.data){
          this.dupSamplesList = 'dupSamples' in results.data ? results.data['dupSamples'] : []
          this.dupPlatesList = 'dupPlates' in results.data ? results.data['dupPlates'] : []
          this.duplicateValues=true
          this.dupSamples = 'dupSamples' in results.data
          this.dupPlates = 'dupPlates' in results.data
        }
        else{
          this.prepareAndAnnouncePlates(results, formData);
        }
      }
      this.manualEXELElement.nativeElement.value = "";
      this.isFileNotSelected = true;
      this.searchAnnounceList(0,10);
      if (this.projectData && this.projectData.length == 1) {
        this.project = this.projectData[0];
      }else{
        this.project = new ArrayProject();
      }
    }, error: (error) => {
      this.manualEXELElement.nativeElement.value = "";
      this.isFileNotSelected = true;
      this.blocked = false;
      let message = this.errorHandler.handleError(error);
      this.duplicateValues=true
      this.errorMessage = message.detail
    }});
  }

  private prepareAndAnnouncePlates(results: BBResponseContainer, formData: FormData) {
    const newPlates: Plate[] = [];
    if ('newPlates' in results.data) {
      results.data['newPlates'].forEach((plateEntry: any) => {
        const plateID = Object.keys(plateEntry)[0];
        const samplesData = plateEntry[plateID];

        const plate = new Plate();

        plate.plateID = plateID;
        plate.lastUpdatedPlateID = plateID;
        plate.status = 'ANNOUNCED';
        plate.version = 0;
        plate.labID = this.selectedLabId;
        plate.delivery = results.data['deliveryID'];
        plate.type = 'PLATE';
        plate.sampleType = formData.get('sampleType') ? String(formData.get('sampleType')) : '';
        plate.scanHorizontal = false;
        plate.storagePlate = false;
        plate['receptionReported'] = false;
        plate.beadChips = [];
        plate.comments = [];
        plate.sourcePlates = [];
        plate.processSteps = [];
        plate.processFlowName = formData.get('processFlowName') ? String(formData.get('processFlowName')) : '';
        plate.priority = 10;
        plate.reRun = false;
        plate.projectID = formData.get('projectID') ? String(formData.get('projectID')) : '';

        const currentDate = new Date();
        const dueDate = new Date(currentDate.setDate(currentDate.getDate() + 5));
        plate.dueDate = dueDate;

        plate['creationDate'] = new Date();
        plate['lastModifiedDate'] = new Date();
        plate.version = 1;

        plate.samples = samplesData.map(sampleData => {
          const sample = new Sample();

          sample._id = sampleData._id;
          sample.position = sampleData.position;
          sample.sampleID = sampleData.barCode;
          sample.sampleType = sampleData.sampleType;
          sample.projectID = plate.projectID;
          sample.beadChipID = '';
          sample.beadChipPosition = '';
          sample.redoBeadChipID = '';
          sample.redoBeadChipPosition = '';
          sample.singleRedo = false;
          sample.plateRedo = false;
          sample.toBePicked = false;
          sample.sourcePlateID = plate.plateID;
          sample.sourcePlatePosition = sample.position;
          sample.boxReceptionTimeStamp = new Date();
          sample.boxID = '';
          sample.priority = 10;
          sample.dueDate = dueDate;
          return sample;
        });
        newPlates.push(plate);
      });
      const request = new PlateAnnouncementDTO();
      request.labID = this.selectedLabId;
      request.newPlates = newPlates;
      if (results.data['receivedPlates'] && results.data['receivedPlates'].length > 0) {
        request.receivedPlates = results.data['receivedPlates'];
      } else {
        request.receivedPlates = [];
      }
      request.puid = this.puid;
      this.announcePlatesToSampleProcessing(request);
    }
  }

  announcePlatesToSampleProcessing(request: PlateAnnouncementDTO){
    this.blocked = true;
    this.announcedService.announcePlates(request).subscribe({
      next: (results) => {
      this.blocked = false;
      this._messagesService.addSuccessMessage({
        severity:'success', summary:'Plate(s) have been successfully announced',
      })
      }, error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:'error', summary:'Failed to announce plates',
          detail: 'Please contact support!'
        })
      }});
  }

  resetValues(){
    this.duplicateValues = false
    this.errorMessage = ''
    this.dupSamples = false
    this.dupSamplesList = []
    this.dupPlates = false
    this.dupPlatesList = []
  }

  clearSearch() {
    this.barCode = '';
    this.fromDate = null;
    this.toDate = null;
    this.searchAnnounceList(0,10)
  }
  exportAnnounced() {
    this.blocked = true;
    let reqBody = {
      barcode: this.barCode,
      fromDate: this.fromDate,
      toDate: this.toDate,
      labId : this.labId
    };
    reqBody.labId = this.selectedLabId;
    if (this.barCode == '' && this.fromDate == null && this.toDate == null) {
      let todayDate = new Date();
      let fromDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate(), 0, 0, 0);
      let toDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate(), 23, 59, 59);
      reqBody.fromDate = fromDate;
      reqBody.toDate = toDate;
      reqBody.labId = this.selectedLabId;
    }
    if (this.fromDate != null) {
      reqBody.fromDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate(), 0, 0, 0);
      reqBody.labId = this.selectedLabId;
    }
    if (this.toDate != null) {
      reqBody.toDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate(), 23, 59, 59)
      reqBody.labId = this.selectedLabId;
    }
    this.announcedService.getExportData(reqBody, 0, 10, true).subscribe(results => {
      let data_: any[] = results.data['data'];
      data_.forEach(announce_ => {
        announce_['announcedDate'] = this.datepipe.transform(announce_['announcedDate'], 'dd/MM/yyyy HH:mm');
        announce_['receivedDate'] = this.datepipe.transform(announce_['receivedDate'], 'dd/MM/yyyy HH:mm');
      });
      this.excelService.exportAsExcelFile(data_, 'announced_data');
      this.blocked = false;
    }, error => {
      this.errorFunction(error);
    });

  }
  errorFunction(error) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  getSelectedProjectSampleType(){
    this.sampleTypeList = [];
    this.selectedProcessFlow = null;
    this.workFlow = this.workFlowData.filter(x => x.workFlowName == this.project.workflow)[0]
    let processFlowList = this.workFlow.processFlow
    this.sampleTypeProcessFlowList.filter(x => processFlowList.includes(x.processFlow)).map((pf) => {
     pf.value.sampleType.split(",").map(item => item.trim()).forEach( sampleType => {
        this.sampleTypeList.push({label: sampleType, value: {"sampleType": sampleType, "processFlowName":pf.value.processFlowName}})
      })
    })
    if(this.sampleTypeList.length == 0){
      this._messagesService.addErrorMessage({
        severity:'error', summary:"No sample types found for workflow - "+this.project.workflow,
        detail:"Please check the MDM configurations and try again."
      })
      return;
    }
    if(this.sampleTypeList && this.sampleTypeList.length == 1 && !this.workFlow.sampleTypeInFile) {
      this.selectedProcessFlow = this.sampleTypeList[0].value;
    }
  }
  
  getProjectList() {
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, "arrayProject", 0, 100, true).subscribe(
      results => {
        this.blocked = false;
        this.projectData = results.data;
        this.projectData.forEach(e=>{
          this.projectList.push({label: e.projectID, value: e});
          this.projectDuplicateMap.set(e.projectID, e.duplicate);
        });
        this.getWorkFlowList();
      },
      (error: any) => {
        this.blocked = false;
        this.showError(error);
        this.getWorkFlowList();
      });

  }
  
  getWorkFlowList() {
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, "workflow", 0, 100, true).subscribe(results => {
      this.blocked = false;
      this.workFlowData = results.data;
      if (this.projectData && this.projectData.length == 1) {
        this.project = this.projectData[0];
        this.getSelectedProjectSampleType();
      }
    },
    (error: any) => {
      this.blocked = false;
      this.showError(error);
    });

  }

  getSampleTypeList() {
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, "processFlow", 0, 100, true).subscribe(results => {
      this.blocked = false;
      this.processFlowData = results.data;
      this.processFlowData.forEach(p=>{
      this.sampleTypeProcessFlowList.push({"processFlow": p.processFlowName, "value": p});
      });
      this.getProjectList();
    },
    (error: any) => {
      this.blocked = false;
      this.showError(error);
      this.getProjectList();
    });

  }
  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

}
